export function currentYear() {
  return new Date().getFullYear()
}

export function getDateValues(format = "number") {
  const today = new Date();

  const monthNumber = String(today.getMonth() + 1).padStart(2, "0"); // 01-12
  const monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const monthName = monthNames[today.getMonth()];
  const date = String(today.getDate()).padStart(2, "0");
  const year = today.getFullYear();

  return {
    date,
    month: format === "name" ? monthName : monthNumber,
    year,
  };
}

export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString();
}

export function formatPrettyDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}


function toUTCDateString(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    .toISOString()
    .substring(0, 10);
}


export function getDateRange(value) {
  const today = new Date();
  let start = null;
  let end = null;

  if (value === "this_month") {
    start = new Date(today.getFullYear(), today.getMonth(), 1);
    end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  }

  if (value === "last_month") {
    start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    end = new Date(today.getFullYear(), today.getMonth(), 0);
  }

  if (value === "this_week") {
    const day = today.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;
    start = new Date(today);
    start.setDate(today.getDate() + diffToMonday);
    end = new Date(start);
    end.setDate(start.getDate() + 6);
  }

  if (value === "last_week") {
    const day = today.getDay();
    const diffToLastMonday = day === 0 ? -13 : -6 - day;
    start = new Date(today);
    start.setDate(today.getDate() + diffToLastMonday);
    end = new Date(start);
    end.setDate(start.getDate() + 6);
  }

  return {
    start: start ? toUTCDateString(start) : null,
    end: end ? toUTCDateString(end) : null,
  };
}


